import React from 'react';
import JITLoad from '~/helpers/jit-load';
import useGiveToday from '~/models/give-today';
import useOptimizedImage from '~/helpers/use-optimized-image';
import './upper-menu.scss';
const menuStructure = {
    'Order Print': '/print/',
    'Our Impact': '/impact',
    Supporters: '/foundation',
    Blog: '/blog',
    Give: 'https://riceconnect.rice.edu/donation/support-openstax-header',
    Help: 'https://help.openstax.org/s/'
};
const menuData = Object.entries(menuStructure).map(([key, value]) => ({ label: key, url: value }));
function MenuItem({ label, url, showButton }) {
    if (label === 'Give') {
        return showButton ?
            null :
            React.createElement("li", { className: "nav-menu" },
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: url }, label));
    }
    return (React.createElement("li", { className: "nav-menu" },
        React.createElement("a", { href: url }, label)));
}
const importGiveButton = () => import('../give-button/give-button');
export default function UpperMenu() {
    const { showButton } = useGiveToday();
    const riceLogo = useOptimizedImage('https://openstax.org/dist/images/rice.webp', 80);
    return (React.createElement("menu", { className: "container", "data-analytics-nav": "Upper Menu" },
        menuData.map(({ label, url }) => React.createElement(MenuItem, { key: label, label: label, url: url, showButton: showButton })),
        React.createElement("li", { className: "logo rice-logo logo-wrapper" },
            React.createElement("a", { href: "http://www.rice.edu" },
                React.createElement("img", { src: riceLogo, alt: "Rice University logo", height: "30", width: "79" }))),
        showButton ? React.createElement(JITLoad, { importFn: importGiveButton }) : null));
}
